import LeftLeafSVG from '../../../../../icons/LeftLeafSVG'
import RightLeafSVG from '../../../../../icons/RightLeafSVG'
import type { PlusBannerItem } from '../../../types/plusBanner.types'

/** Presentational row inside the clickable plus-banner card (parent owns the action). */
export function ElitePlansPlusBannerRow({ item }: { item: PlusBannerItem }) {
  const label = item.label ?? ''
  const sublabel = item.sublabel ?? ''
  const price = item.price ?? ''
  const feeLabel = item.feeLabel ?? ''
  const feeLabelStrike = item.feeLabelStrike ?? ''
  const feeLabelSuffix = item.feeLabelSuffix ?? ''
  const isEmphasis = item.tone === 'emphasis'

  return (
    <div className='flex min-h-[72px] w-full items-center gap-3 px-4 py-3.5 text-left'>
      <span className='min-w-0 flex-1'>
        <span
          className={`flex items-center text-[14px] font-medium leading-[1.3] ${
            isEmphasis ? 'text-[color:var(--ep-plus-strong)]' : 'text-[color:var(--ep-plus-text)]'
          }`}
        >
          {item.showLeaves ? (
            <LeftLeafSVG size={12} color='var(--ep-plus-strong)' className='shrink-0' />
          ) : null}
          <span>{label}</span>
          {item.showLeaves ? (
            <RightLeafSVG size={12} color='var(--ep-plus-strong)' className='shrink-0' />
          ) : null}
        </span>
        {sublabel ? (
          <span
            className={`mt-0.5 block text-[12px] font-normal leading-[1.4] ${
              isEmphasis ? 'text-[color:var(--ep-plus-strong-subtle)]' : 'text-[color:var(--ep-plus-subtle)]'
            }`}
          >
            {sublabel}
          </span>
        ) : null}
      </span>

      <span className='shrink-0 text-right'>
        <span
          className={`block text-sm font-medium leading-[1.3] ${
            isEmphasis ? 'text-[color:var(--ep-plus-price-strong)]' : 'text-[color:var(--ep-plus-text)]'
          }`}
        >
          {price}
          {item.priceSuffix ? (
            <span
              className={
                isEmphasis
                  ? 'text-[rgba(128,60,37,0.50)] text-xs'
                  : 'text-xs font-medium text-[color:var(--ep-plus-subtle)]'
              }
            >
              {item.priceSuffix}
            </span>
          ) : null}
        </span>
        {feeLabel ? (
          <span
            className={`mt-0.5 block text-[12px] font-normal leading-[1.4] ${
              isEmphasis ? 'text-[color:var(--ep-plus-strong-subtle)]' : 'text-[color:var(--ep-plus-subtle)]'
            }`}
          >
            {feeLabel}
            {feeLabelStrike ? (
              <>
                {' '}
                <span className='line-through opacity-70'>{feeLabelStrike}</span>
              </>
            ) : null}
            {feeLabelSuffix}
          </span>
        ) : null}
      </span>
    </div>
  )
}
